import React, { useState } from 'react';

const Button16 = ({
    children,
    onClick,
    variant = 'primary',
    className = '',
    disabled = false,
    type = 'button',
}) => {
    const [hovered, setHovered] = useState(false);

    const baseStyle = {
        fontFamily: "'Poppins', sans-serif",
        fontSize: '13px',
        fontWeight: 500,
        letterSpacing: '2px',
        textTransform: 'uppercase',
        padding: '14px 32px',
        border: 'none',
        borderRadius: '0',
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.5 : 1,
        transition: 'all 0.3s ease',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        textDecoration: 'none',
    };

    const variants = {
        primary: {
            default: {
                backgroundColor: '#991B1B',
                color: '#FFFFFF',
                border: '1px solid #991B1B',
            },
            hover: {
                backgroundColor: '#7F1D1D',
                color: '#FFFFFF',
                border: '1px solid #7F1D1D',
            },
        },
        gold: {
            default: {
                backgroundColor: '#B8860B',
                color: '#FFFFFF',
                border: '1px solid #B8860B',
            },
            hover: {
                backgroundColor: '#9A7209',
                color: '#FFFFFF',
                border: '1px solid #9A7209',
            },
        },
        outline: {
            default: {
                backgroundColor: 'transparent',
                color: '#991B1B',
                border: '1px solid #991B1B',
            },
            hover: {
                backgroundColor: '#991B1B',
                color: '#FFFFFF',
                border: '1px solid #991B1B',
            },
        },
        ghost: {
            default: {
                backgroundColor: 'transparent',
                color: '#991B1B',
                border: '1px solid transparent',
            },
            hover: {
                backgroundColor: 'rgba(153, 27, 27, 0.08)',
                color: '#991B1B',
                border: '1px solid transparent',
            },
        },
    };

    const currentVariant = variants[variant] || variants.primary;
    const variantStyle = hovered && !disabled ? currentVariant.hover : currentVariant.default;

    return (
        <button
            type={type}
            onClick={disabled ? undefined : onClick}
            disabled={disabled}
            className={className}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
            style={{ ...baseStyle, ...variantStyle }}
        >
            {children}
        </button>
    );
};

export default Button16;
